import { z } from 'zod';
const Id = z.string().guid();
export const RecordCorrelationSchema = z
    .object({
    conversationId: z.string().regex(/^conv_[A-Za-z0-9_-]{1,190}$/),
    agentReference: z.string().regex(/^[A-Za-z0-9_-]{1,200}$/),
})
    .strict();
export const CorrelationSchema = RecordCorrelationSchema.extend({
    state: z.enum(['pending', 'processing', 'bound', 'ignored', 'blocked']),
    version: z.number().int().positive(),
    attempts: z.number().int().nonnegative(),
    leaseToken: Id.nullable(),
    leaseExpiresAt: z.string().datetime().nullable(),
    retryAt: z.string().datetime().nullable(),
    reason: z
        .enum([
        'metadata_unavailable',
        'waiting_attempt',
        'waiting_dispatch',
        'route_unverified',
        'busy',
        'transient',
        'conflict',
        'not_outbound',
    ])
        .nullable(),
    organizationId: Id.nullable(),
    callAttemptId: Id.nullable(),
    sessionId: Id.nullable(),
}).strict();
export const CorrelationClaimSchema = z
    .object({ limit: z.number().int().min(1).max(100).default(10) })
    .strict();
export const CorrelationClaimsSchema = z.object({ items: z.array(CorrelationSchema) }).strict();
export const CorrelationTransitionSchema = z
    .object({
    expectedVersion: z.number().int().positive(),
    leaseToken: Id,
    state: z.enum(['pending', 'bound', 'ignored', 'blocked']),
    retryAt: z.string().datetime().optional(),
    reason: CorrelationSchema.shape.reason.optional(),
    organizationId: Id.optional(),
    callAttemptId: Id.optional(),
    sessionId: Id.optional(),
})
    .strict()
    .superRefine((value, context) => {
    if (value.state === 'pending' && !value.retryAt)
        context.addIssue({ code: 'custom', message: 'Pending work requires backoff' });
    if (value.state === 'bound' &&
        (!value.organizationId || !value.callAttemptId || !value.sessionId))
        context.addIssue({ code: 'custom', message: 'Bound work requires ownership' });
});
export const CorrelationLookupSchema = z.object({ callAttemptId: Id, operationId: Id }).strict();
export const CorrelationOwnerSchema = z.object({ organizationId: Id }).strict();
//# sourceMappingURL=correlations.js.map